// src/app/core/shared/t0-model/t0-baseline.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

import { AnalysisStore } from './analysis.store';
import { T0ApiResponse } from './t0-response-model';

const MODEL = 't0';

@Injectable({ providedIn: 'root' })
export class T0BaselineService {
  private readonly baselineUrl = `${environment.apiUrl}/city_baseline`;

  constructor(private http: HttpClient, private store: AnalysisStore) {}

  async resetAndReloadBaselineForCity(city: string): Promise<void> {
    const normalizedCity = String(city || '').trim();
    if (!normalizedCity) {
      throw new Error('Missing city.');
    }

    const session_id = this.ensureSessionId();
    this.store.clearAllRuns();

    const t0 = await this.fetchBaseline(normalizedCity, session_id);
    this.store.setBaselineRun(t0, normalizedCity);
  }

  private async fetchBaseline(city: string, session_id: string): Promise<T0ApiResponse> {
    const params = new HttpParams().set('model', MODEL).set('city', city).set('session_id', session_id);

    // Base64 endpoint: read as text and decode
    const text = await firstValueFrom(
      this.http.get(this.baselineUrl, { params, responseType: 'text' })
    );

    const res = this.decodeB64Json<any>(text);

    if (!res || String(res.status || '').toLowerCase() !== 'success' || !Array.isArray(res.years)) {
      throw new Error(res?.message || 'Baseline request failed.');
    }

    return res as T0ApiResponse;
  }

  private decodeB64Json<T>(b64: string): T {
    try {
      const json = atob((b64 || '').trim());
      return JSON.parse(json) as T;
    } catch {
      // if backend ever returns plain JSON, fall back safely
      return JSON.parse((b64 || '') as any) as T;
    }
  }

  private ensureSessionId(): string {
    const key = 'session_id';
    let id = sessionStorage.getItem(key) || '';
    if (!id) {
      id = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      try {
        sessionStorage.setItem(key, id);
      } catch {}
    }
    return id;
  }
}